module.exports = __webpack_public_path__ + "media/src/img/ok-icon-blue-e5c487d89e4a6462aeb5453fa584800d.svg";